import { useEffect, useState } from 'react';
import SchemaRepo from '../../../../utils/repository/schemaRepo';
import { SchemaType } from '../types';

function useSchema(schemaId: number | undefined): [SchemaType | null, boolean] {
    const [data, setData] = useState<SchemaType | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (schemaId) {
            setIsLoading(true);
            SchemaRepo.get(schemaId, (schema: SchemaType) => {
                setData(schema);
                setIsLoading(false);
            });
        }
    }, [schemaId]);

    return [data, isLoading];
}

export default useSchema;
